<template>
  <div v-show="showDownloadBtnStatus" class="downloadbtn">
    <a href="" :id="mlinkid" ref="mlinkref"></a>
    <img @click.stop="openApp" :src="downloadAppImg" alt="">
  </div>
</template>
<script>
// import base64 from 'base-64'
import mwtemplate from './mwtemplate'
export default {
  data () {
    return {
      mlink: '',
      showDownloadBtnStatus: false,
      downloadAppImg: tuhu.downloadAppImg,
      mlinkid: tuhu.util.getGroup()
    }
  },
  props: {
    nativeurl: {
      type: String,
      default: '/home?v=1'
    },
    forceredirect: {
      type: Number,
      default: 0
    },
    eventaction: {
      type: String,
      detault: 'downloadapp_click'
    },
    callbackfun: {
      type: Function
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      // this.downloadinit()
      setTimeout(() => {
        this.downloadappinit()
        this.$emit('callbackfun', this.showDownloadBtnStatus)
      }, 500)

      const ua = navigator.userAgent || ''
      let myAppUrl = 'tuhu://explore'
      if (ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1) {
        myAppUrl = 'tuhu:'
      }

      if (this.nativeurl.indexOf('http') === 0) {
        myAppUrl = 'tuhu://explore/webView?url='
      }

      const link = tuhu.getParam('nativeurl') || `${myAppUrl}${this.nativeurl}`
      const redirect = tuhu.getParam('forceredirect') || this.forceredirect
      this.mlink = decodeURIComponent(`${link}`)
      if (redirect && parseInt(redirect)) {
        location.href = this.mlink
      }
    },
    downloadappinit() {
      const channelInfo = tuhu.channelInfo
      let status = false
      if (channelInfo) {
        status = channelInfo.isShowDownLoadBtn
      }
      if (tuhu.getParam('hidedownload')) {
        status = false
      }
      if (tuhu.isLightApp) {
        status = false
      }
      this.showDownloadBtnStatus = status
    },
    downloadinit() {
      tuhu.script('https://static.mlinks.cc/scripts/dist/mlink.min.js')
    },
    openApp() {
      Ta.ta('event', 'mw_openapp_img_click', {
        channel: tuhu.orderChannel || 'kH5'
      })
      tuhu.tPopup.popupData(mwtemplate, {
        wrapCla: 'mw_centerMiddle', // 最外层追加的Class名
        isShowCloseBtn: false,
        alignCla: 'centerMiddle', // ''|'bottom'|'top'|'fullScreen'|'centerMiddle',
        transitionCls: 't_scale', // ''|'t_toUp'|'t_scale'|'t_toBottom'|'t_toLeft';
        props: {
          mlink: this.mlink
        }
      }).then(data => {
        if (data && data.type === 'close') {
          Ta.ta('event', 'mw_close_click', {
            channel: tuhu.orderChannel || 'kH5'
          })
        }
      })
      // if (tuhu.orderChannel === 'zhidemai') {
      //   // 值得买特殊处理 CPSZDMParameters
      //   const feedback = tuhu.util.getCookie('CPSZDMParameters')
      //   this.mlink = `${this.mlink}&feedback=${feedback}`

      //   location.href = this.mlink
      // }

      // try {
      //   const data = base64.encode(JSON.stringify({
      //     url: this.mlink
      //   }))
      //   const id = this.mlinkid

      //   new window.Mlink({
      //     mlink: 'AakR',
      //     button: document.querySelector('a#' + id),
      //     params: {data: data}
      //   })
      // } catch (e) {
      //   tuhu.toast('网络异常')
      // }

      // setTimeout(() => {
      //   try {
      //     const id = this.mlinkid
      //     const aDom = document.querySelector('#' + id)

      //     aDom && aDom.dispatchEvent(new MouseEvent('click'))
      //   } catch (e) {
      //     try {
      //       this.$refs.mlinkref.click()
      //     } catch (e) {
      //       tuhu.toast('系统异常')
      //     }
      //   }
      // }, 2000)
    }
  }
}
</script>
<style lang="less" scoped>
  .downloadbtn{
    height: 3.25rem;
    z-index: 20;
    img{
      height: 3.25rem;
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// lib/pages/_search/wm.vue